(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('formFields', formFields);

    /* @ngInject */
    function formFields() {
        var directive = {
            templateUrl: 'form-fields.tpl',
            bindToController: true,
            controller: formFieldsCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'C',
            require: ['?fields', '?fieldModel', '?fieldPath', '?parentKey'],
            scope: {
                fields: '=',
                settings: '<',
                formId: '<',
                formModel: '=',
                fieldPath: '@',
                parentKey: '@',
                topModel: '='
            }
        };
        return directive;

        function link(scope, element, attrs, fields, fieldModel, fieldPath, parentKey) {
            scope.isForm = scope.vm.fieldPath == '';
            if (scope.isForm) {
                scope.vm.useCaptcha = scope.$root.checkChain(scope.vm, 'settings,captcha,value') ? scope.vm.settings.captcha.value : false;
                scope.vm.captchaSettings = scope.$root.globals.site_options.captcha || {};
                if (scope.vm.useCaptcha &&  scope.vm.captchaSettings['site-key']) {
                    scope.captchaToken = '';
                    scope.initCaptcha();
                }
                scope.vm.saving = false;
                scope.vm.modal = scope.$root.checkChain(scope.vm, 'settings,submit-modal,value')  ? scope.vm.settings['submit-modal'].value : false;
                // scope.preValidated = !scope.vm.modal;
                scope.$on('submit-modal-ok', function(e) {
                    scope.submitForm(e);
                    scope.$root.modalClose();
                });
                scope.vm.preloader = '';
            }

            scope.vm.renderAsAccordion = false;
            if(typeof scope.vm.fieldModel === 'undefined') { scope.vm.fieldModel = {}; }
            if (angular.isObject(scope.vm.settings) &&  angular.isObject(scope.vm.settings.accordion) &&   scope.vm.settings.accordion.value === true) {
                scope.vm.renderAsAccordion = true;
                var fa = scope.vm.fields.find(function(e) {
                    return angular.isDefined(e.activeAccordionItem);
                });
                scope.vm.activeAccordionItem = !fa ? scope.vm.fields[0].name : fa.name;
            }
        }
    }

    /* @ngInject */
    function formFieldsCtrl($scope,$http,$location,$route) {
        $scope.$on("accordion-toggle", function(e, fieldKey) {
            if ($scope.vm.renderAsAccordion) {
                $scope.$root.$broadcast("accordion-tab", fieldKey);
                $scope.vm.activeAccordionItem = fieldKey;
            }
        });

        $scope.cLogic = function(fidx) {
            var result = (angular.isDefined($scope.vm.fields[fidx]['frontend-hide']) && $scope.vm.fields[fidx]['frontend-hide']) ? false : true;

            if (angular.isDefined($scope.vm.fields[fidx]['c-logic']) && ($scope.vm.fields[fidx]['c-logic'].length > 0) && angular.isDefined($scope.vm.topModel)) {
                var ruleResults = [];
                angular.forEach($scope.vm.fields[fidx]['c-logic'], function(rule, i) {
                    var fieldValue = $scope.getValue($scope.vm.topModel,rule.path.split('|'));
                    var vvv = $scope.compare(fieldValue, rule.value, rule.operator);

                    ruleResults.push({
                        v: vvv,
                        r: rule.relation
                    });
                });

                // + hastily solution :)

                result = ruleResults[0].v;
                for(var i = 1; i < ruleResults.length; i++) {
                    result = $scope.compare(ruleResults[i].v,result,ruleResults[i].r);
                }

                // - hastily solution
            }
            return result;
        };


        $scope.getValue = function (a,path) {
            var p = a;
            for(var i = 0; i < path.length; i++) {
                if (angular.isDefined(p[path[i]])) {
                    p = p[path[i]];
                } else {
                    return null;
                }
            }
            return p.value;
        };

        $scope.compare = function(fieldValue, ruleValue, operator) {
            var result = false;

            // + due old chechbox model

            if (angular.isObject(fieldValue) && !angular.isArray(fieldValue)) {
                var t = [];
                for(var k in fieldValue) {
                    if (fieldValue[k]) {
                        t.push(k);
                    }
                }
                fieldValue = t;
            }

            // - due old checkbox model

            switch(operator) {
                case '==':
                    result = (fieldValue == ruleValue);
                break;

                case '!=':
                    result =  (fieldValue != ruleValue);
                break;

                case 'in':
                    result = fieldValue.some(function(val) {
                        return (ruleValue.indexOf(val) != -1);
                    });
                break;

                case 'not in':
                    result =  fieldValue.any(function(val) {
                        return (ruleValue.indexOf(val) == -1);
                    });
                break;

                case 'and':
                    result = fieldValue && ruleValue;
                break;

                case 'or':
                    result = fieldValue ||  ruleValue;
                break;
            }
            return result;
        };

        $scope.animatePreloader = function(start) {
            $scope.vm.saving = start;
            if (start) {
                $scope.vm.pTimer = setInterval(function() {
                    if ($scope.vm.preloader.length == 3) {
                        $scope.vm.preloader = '';
                    } else {
                        $scope.vm.preloader += '.';
                    }
                    angular.element('#preloader').text('Processing ' + $scope.vm.preloader);
                }, 500);
            } else {
                clearInterval($scope.vm.pTimer);
            }
        };

        $scope.submitForm = function(e) {
            var invalids = angular.element('.ng-invalid');
            if (invalids.length > 0) {
                invalids.each(function(iel,el) {
                    angular.element(el).removeClass('ng-untouched').addClass('ng-touched');
                });
                $scope.$root.errorMessage = 'Please fill out ' + angular.element(invalids[0]).closest('.form-field').find('label').html();
                $scope.$root.openModal("error-modal");
                return;
            }

            function sendRequest() {
                $scope.animatePreloader(true);
                var params = {
                    formId: $scope.vm.formId,
                    data: angular.copy($scope.vm.topModel)
                };
                if ($scope.vm.modal && e.name != 'submit-modal-ok') {
                    params.data.validation = true;
                }

                if ($scope.captchaToken != '') {
                    params.data.captchaToken = $scope.captchaToken;
                }

                if (typeof $scope.ajaxData !== 'undefined') {
                    for(var i in $scope.ajaxData) {
                        params.data[i] =  $scope.ajaxData[i];
                    }
                }

                var adata = {
                    action: 'lbs-action',
                    method: 'form_processor',
                    module: 'cfd',
                    nonce: $scope.$root.stats.nonce,
                    params: params

                };
                $http.post(window.ajaxurl, adata).then(function(response) {
                    if (!angular.isDefined(response.data.redirectUrl) || response.data.redirectUrl == '#') {
                        if (!angular.isDefined(response.data.not_last) || !response.data.not_last) {
                            $scope.animatePreloader(false);
                        }
                    }
                    if (response.data.result) {
                        if (angular.isDefined(response.data.message)) {
                            $scope.vm.successMessage = response.data.message;
                            setTimeout(function() {
                                $scope.vm.successMessage = '';
                                $scope.$apply();
                            }, 5000);
                        }
                        if (angular.isDefined(response.data.redirectUrl)) {
                            if (response.data.redirectUrl != '#') {
                                $location.url(response.data.redirectUrl);
                            }
                        } else {
                            $route.reload();
                        }
                        return Promise.resolve();
                    } else {
                        return Promise.reject(response.data);
                    }
                }).catch(function(err) {
                    $scope.$root.errorMessage = '';
                    $scope.captchaToken = '';
                    if (err.validated) {
                        if ($scope.ajaxData && $scope.ajaxData.paymentResult) {
                            $scope.ajaxData.paymentResult = null;
                        }

                        $scope.$root.openModal("submit-modal");
                    } else if (err.payload && err.payload.confirmPayment) {
                        $scope.ajaxData = err.payload;
                        if (typeof window.confirmPayment !== 'undefined') {
                            window.confirmPayment(err.payload.confirmPayment, $scope.paymentCallback);
                        }
                    } else {
                        if (err.payload) {

                            $scope.ajaxData = err.payload;
                        }
                        $scope.$root.errorMessage = err.message   || 'Something went wrong. Please DO NOT resubmit and use Contact form to report the error. We apologize for the inconvenience!';
                        $scope.$root.openModal("error-modal");
                        $scope.animatePreloader(false);
                    }
                });
            }
            $scope.paymentPrepared = false;
            $scope.sendRequest = sendRequest;
            $scope.vm.errorMessage = '';

            if (
                (typeof window.preparePayment == 'function') &&
                (window.paymentMethodName  == 'wallet') &&
                  !$scope.paymentPrepared &&
                  (window.cartTotal > 0) &&
                  (($scope.vm.modal && e.name == 'submit-modal-ok')  || !$scope.vm.modal)
                ) {
                window.preparePayment($scope.paymentCallback);
                return false;
            }
            $scope.captchaToken = '';

            $scope.sendRequestWithCaptcha();
        };

        $scope.sendRequestWithCaptcha = function() {
            if ($scope.vm.useCaptcha && (typeof grecaptcha !== 'undefined')  &&
                // (($scope.captchaToken == '') || (window.cartTotal == 0)))
                ($scope.captchaToken == ''))
            {
                grecaptcha.ready(function() {
                    grecaptcha
                    .execute($scope.vm.captchaSettings['site-key'], { action: 'action_name' })
                    .then(function(token) {
                        $scope.captchaToken = token;
                        $scope.sendRequest();
                    });
                });
            } else {
                $scope.sendRequest();
            }
        };

        $scope.paymentCallback = function(resp) {
            $scope.animatePreloader(false);
            if (resp.ok) {
                if (resp.payload) {
                    $scope.ajaxData.paymentResult = resp.payload;
                } else {
                    $scope.paymentPrepared = true;
                }
                // console.log('before request');
                $scope.sendRequestWithCaptcha();
            } else {
                // $scope.$root.errorMessage = resp.message;
                // $scope.$root.openModal("error-modal");
                $scope.ajaxData.paymentResult = {message: resp.message};
                $scope.sendRequestWithCaptcha();
            }
        };

        $scope.initCaptcha = function() {
            var url = 'https://www.google.com/recaptcha/api.js?render=' + $scope.vm.captchaSettings['site-key'];
            var type = 'text/javascript';
            var head = document.getElementsByTagName("head")[0];
            var script = document.querySelector("script[src*='" + url + "']");
            if (!script) {
                script = Object.assign(document.createElement('script'), {
                    src: url,
                    type: type
                });
                head.appendChild(script);
            }
        };
    }
})();